import { render, staticRenderFns } from "./OrganizationStructure.vue?vue&type=template&id=65eedb61&"
import script from "./OrganizationStructure.vue?vue&type=script&lang=js&"
export * from "./OrganizationStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports